import { SequenceMenu } from '@sequencehq/core-components'
import { DeleteCreditGrantModal } from '../modals/deleteCreditGrant/DeleteCreditGrantModal'
import { RedRed50 } from '@sequencehq/core-components'
import { usePermissions } from 'lib/rbac'

export const DeleteCreditGrantMenuItem = (props: {
  creditGrantId: string
  creditGrantName: string
  onClose?: () => void
  disabled?: boolean
  'data-testid'?: string
}) => {
  const { can } = usePermissions()

  if (!can('org.billing:delete')) {
    return null
  }

  return (
    <DeleteCreditGrantModal
      creditGrantId={props.creditGrantId}
      creditGrantName={props.creditGrantName}
      onClose={() => props.onClose?.()}
      trigger={
        <SequenceMenu.Item
          uuid="delete-credit-grant"
          label="Delete credit grant"
          style={{ color: RedRed50 }}
          isDisabled={props.disabled}
          data-testid={props['data-testid'] ?? 'deleteCreditGrant.menuItem'}
        />
      }
    />
  )
}
